
$(() => {
       
        $('.ns-gallery-item').on('click', function () {
                let galleryId = $(this).parents().parents().parents().attr('id')
                _shelf = $(this).parent()
                _all = $(this).parent().parent().children("li")
                let cclass = "GI_TW_Index-"+_all.index(_shelf)
                let desc = document.querySelector('#'+ galleryId + " .descriptor")
                
                if (typeof (desc) != 'undefined' && desc != null) {
                        desc.remove()
                }

                let tmp = $(this).children().first().data('desc')
                console.log('hier click');
                console.log(tmp)
                console.log($(this))
                console.log($(this).children())
                console.log($(this).children().first())
                console.log($(this).children().first().data('desc'))
                console.log('aftermath');

                //let galleryId = $(this).parents().parents().parents().attr('id')
                if (tmp.length > 0) {
                        console.log("inhere")
                        let ele = document.createElement('div')
                        ele.classList = "descriptor"
                        ele.dataset.galleryid = galleryId
                        ele.dataset.cclass = cclass
                        ele.innerHTML = tmp
                        let tar = document.querySelector(".ns-gallery-google-view " +'#'+ galleryId + " .GI_TW_expander")
                        tar.appendChild(ele)

                }
 
                let nexts = document.querySelectorAll(".GI_TW_next")
                for (let i = 0; i < nexts.length; i++) {
                        nexts[i].setAttribute("onclick",'bwgin($(this))');
                        
                }
                        
                let prevs = document.querySelectorAll(".GI_TW_prev")
                for (let i = 0; i < prevs.length; i++) {
                        prevs[i].setAttribute("onclick",'bwgip($(this))');
                        
                }
                
                
               
             //   document.querySelector(".GI_TW_next").setAttribute("onclick",GI($(this)))
               
           //     document.querySelector(".GI_TW_prev").setAttribute("onclick",GI($(this),"prev"))
        

        })

        let i2 = document.querySelectorAll('.ns-gallery-google-view-item a')
        i2.forEach(el => {
                el.setAttribute('draggable',false)
        })

        let items = document.querySelectorAll('.ns-gallery-google-view-item')
        items.forEach(elem => {
                elem.setAttribute('draggable',false)
        })



})



/*

		$(".GI_TW_next").on("click", function () {
			var _self = $(this)
			var _shelf = this
			console.log(_self.parent())
			let gid = _self.parent().find('.descriptor').data("galleryid")
			let iid = _self.parent().find('.descriptor').data("cclass")
			let sel = "." + gid + " ." + iid 
			console.log(sel)
			let txt = $(sel).next().find("img").data("desc")
			$(".descriptor").html(txt)
		})


*/